<div class="setting-tabs">
<sync-tabs
[tabLinks]="navLinks"
[tabsPosition]="'center'"
[onSelectionTab]="handleTabClick"
></sync-tabs>
</div>
<div class="tab-container">
    <router-outlet></router-outlet>
</div>